export default "__VITE_ASSET__gsUJ14GH__"